import { useState, useEffect } from "react";
import { t } from "@/lib/i18n";
import { toast } from "sonner";
import { Translate } from "@phosphor-icons/react";
import api, { errDetail } from "@/lib/api";

const CODES = ["af","am","ar","az","be","bg","bn","bs","ca","cs","cy","da","de","el","en","es","et","eu","fa","fi","fil","fr","ga","gl","gu","he","hi","hr","hu","hy","id","is","it","ja","ka","kk","km","kn","ko","ky","lo","lt","lv","mk","ml","mn","mr","ms","my","ne","nl","no","pa","pl","ps","pt","ro","ru","si","sk","sl","sq","sr","sv","sw","ta","te","th","tr","uk","ur","uz","vi","zh","zu"];

export const languageOptions = () => {
  let dn;
  try { dn = new Intl.DisplayNames(["en"], { type: "language" }); } catch { dn = null; }
  let native;
  try { native = (c) => new Intl.DisplayNames([c], { type: "language" }).of(c); } catch { native = () => ""; }
  return CODES.map((c) => {
    const en = dn ? dn.of(c) : c;
    let nat = "";
    try { nat = native(c); } catch { nat = ""; }
    return { code: c, label: nat && nat !== en ? `${en} — ${nat}` : en };
  }).sort((a, b) => a.label.localeCompare(b.label));
};

export const AgentLanguageSelect = ({ value, onChange, testId }) => (
  <select data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)}
    className="border border-gray-300 rounded-md px-2 py-2 text-sm bg-white max-w-[320px]">
    <option value="auto">{t("lang.auto", "Auto — mirror the language I write in")}</option>
    {languageOptions().map((o) => <option key={o.code} value={o.code}>{o.label}</option>)}
  </select>
);

export const AgentLanguageCard = () => {
  const [lang, setLang] = useState("auto");
  useEffect(() => {
    api.get("/me/agent-language").then((r) => setLang(r.data.language || "auto")).catch(() => {});
  }, []);
  const save = async (v) => {
    setLang(v);
    try { await api.put("/me/agent-language", { language: v }); toast.success(t("lang.saved", "Agent language saved")); }
    catch (e) { toast.error(errDetail(e)); }
  };
  return (
    <div data-testid="agent-language-card" className="bg-white border border-gray-200 rounded-md p-5 mb-6">
      <div className="flex items-center gap-2 mb-1">
        <Translate size={20} className="text-blue-600" />
        <h3 className="font-heading font-bold text-gray-900">{t("lang.title", "Agent language")}</h3>
      </div>
      <p className="text-xs text-gray-500 mb-3">
        {t("lang.desc", "The language your agent uses to talk to YOU (chat answers, WhatsApp digests, alerts). Emails to your contacts keep their own language.")}
      </p>
      <AgentLanguageSelect value={lang} onChange={save} testId="agent-language-select" />
    </div>
  );
};
